import { Suspense, lazy } from 'react';
import useHomePageStore from '@store/HomePageStore';
import { useUserProfile } from '@hooks/useUserProfile';
import { UserRoles } from '@interfaces/user';
import useAppInitStore from '@store/AppInitStore';
import { Box, CircularProgress, Typography } from '@mui/material';

const BaseHomePage = lazy(() => import('./components/BaseHomePage'));
const LandingPage = lazy(() => import('./components/LandingPage'));
const AdminHomePage = lazy(() => import('./components/AdminHomePage'));
const NonLearnerHomePage = lazy(() => import('./components/NonLearnerHomePage'));

export const Home = () => {
  const { ipedsId } = useHomePageStore((state) => state.adminHomePageData);
  const { id } = useHomePageStore((state) => state.landingPageSchoolData);
  const { role } = useUserProfile();
  const { isInitialized } = useAppInitStore();

  const currentUserIsAdmin = role === UserRoles.Admin;

  const isUserAdmin = !!ipedsId && currentUserIsAdmin;

  if (!isInitialized || role === undefined) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
        <CircularProgress />
        <Typography variant="subtitle2">Getting everything ready...</Typography>
      </Box>
    );
  }

  if (isUserAdmin) {
    return (
      <Suspense fallback={null}>
        <AdminHomePage />
      </Suspense>
    );
  }

  if (role !== UserRoles.Learner) {
    return (
      <Suspense fallback={null}>
        <NonLearnerHomePage />
      </Suspense>
    );
  }

  if (id) {
    return (
      <Suspense fallback={null}>
        <LandingPage />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={null}>
      <BaseHomePage />
    </Suspense>
  );
};
